import { validateHorizontalPosition } from "@angular/cdk/overlay";
import { Address } from "ngx-google-places-autocomplete/objects/address";

export class CustomerAddress 
{
    public SetDataFromAutoComplete(address:google.maps.places.PlaceResult, originID:string)
    {
        this.Latitude = address.geometry?.location.lat() || 0;
        this.Longititude = address.geometry?.location.lng() || 0;

        this.AddressString = address.formatted_address || "";
        this.Url = `https://www.google.com/maps/search/?api=1&query=${this.Latitude},${this.Longititude}&query_place_id=${address.place_id}`;

        var street = address.address_components?.find(x => x.types.includes("route"));

        if (street != undefined)
            this.Street = street.long_name;

        var placeNumber = address.address_components?.find(x => x.types.includes("street_number"));

        if (placeNumber != null)
            this.Number = placeNumber.long_name;

        var neighbourhood = address.address_components?.find(x => x.types.includes("sublocality_level_1" || "sublocality" || "locality"));

        if (neighbourhood != null)
            this.Neighborhood = neighbourhood.long_name;

        this.OriginID = originID;
    }

    public SetDataFromLocation(street:string, placenumber:string, neighbourhood:string, zipcode:string, distance:number, lat:number, lng:number, addressString:string, originID:string, locationID:string)
    {
        this.Distance = distance;
        this.Latitude = lat;
        this.Longititude = lng;

        this.AddressString = addressString;
        this.Url = `https://www.google.com/maps/search/?api=1&query=${this.Latitude},${this.Longititude}&query_place_id=${locationID}`;

        this.Street = street;

        this.Number = placenumber;

        this.Neighborhood = neighbourhood;
        
        this.ZipCode = zipcode;

        this.OriginID = originID;
    }

    public setNeighobourhood(neighbourhood:string)
    {
        this.Neighborhood = neighbourhood;
    }

    setDistance(distance: number) 
    {
        this.Distance = distance;
    }

    public setLocationName(locationname:string)
    {
        this.Location = locationname;
    }

    public SetLine2(line2:string)
    {
        this.Reference = line2;
    }

    public Location:string = '';
    public Reference:string = '';
    public Street:string = '';
    public Number:string = '';
    public Neighborhood:string = '';
    public ZipCode:string = '';

    public Latitude:number = 0;
    public Longititude:number = 0;

    public AddressString:string = '';
    public Url:string = '';

    public Distance:number = 0;

    public OriginID = '';

    public get FullAdress()
    {
        if (this.AddressString.length > 0)
            return this.AddressString;
        else
            return `${this.Reference} - ${this.Street}, ${this.Number}, ${this.Neighborhood}`;
    }
}
